import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { AtendimentosDoAluno } from '@/features/atendimentos/componentes/AtendimentosDoAluno';
import { CursosDoAluno } from '@/features/cursos/componentes/CursosDoAluno';
import { DocumentosDoAluno } from '@/features/documentos/componentes/DocumentosDoAluno';
import { ABAS_DO_ALUNO } from '@/features/usuarios/abas';
import { RegistrosDoAluno } from '@/features/registros/componentes/RegistrosDoAluno';
import { DetalheDoAluno } from '@/features/usuarios/componentes/DetalheDoAluno';

const busca = z.object({ aba: z.enum(ABAS_DO_ALUNO).default('perfil').catch('perfil') });

/** Detalhe do aluno (spec 006, CA-07). */
export const Route = createFileRoute('/_autenticado/alunos/$id')({
  ...rotaDeTela('alunos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  const { aba } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DetalheDoAluno
      key={id}
      id={id}
      aba={aba}
      atendimentos={<AtendimentosDoAluno alunoId={id} />}
      treinos={<RegistrosDoAluno alunoId={id} />}
      documentos={<DocumentosDoAluno alunoId={id} />}
      cursos={<CursosDoAluno alunoId={id} />}
      aoMudarAba={(nova) => {
        void navigate({ search: { aba: nova }, replace: true });
      }}
      aoRemover={() => {
        void navigate({ to: '/alunos' });
      }}
    />
  );
}
